var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab_home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.12207 7.5V17.5H16.6221V7.5L10.3721 2.5L4.12207 7.5Z",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.28857 12.0835V17.5002H12.4552V12.0835H8.28857Z",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.12207 17.5H16.6221",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNo);
export default __webpack_public_path__ + "static/media/home-no.fc535a9241b344a905ee945278c376a0.svg";
export { ForwardRef as ReactComponent };